import { searchApiClient } from '@/datasources/search.datasource';
import {
  SearchApiListResponse,
  SearchApiScheduleGroup,
} from '@/app/(main)/(pages)/_types/search-api-response.type';
import { SearchSortType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-sort.type';
import { SearchFilterDayTimeType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-day-time.type';
import { SearchFilterProfessionalGenderType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-professional-gender.type';
import { toSearchApiOrderBy } from '@/app/(main)/(pages)/busca/[slug]/_utils/search-sort-api.util';
import { toSearchApiDayTime } from '@/app/(main)/(pages)/busca/[slug]/_utils/search-day-time-api.util';
import { toSearchApiProfessionalGender } from '@/app/(main)/(pages)/busca/[slug]/_utils/search-professional-gender-api.util';
import { toSearchApiScheduleTypes } from '@/app/(main)/(pages)/busca/[slug]/_utils/search-schedule-types-api.util';

export interface FindSchedulesByProceduresParams {
  procedureIds?: string[];
  procedureCodes?: string[];
  city?: string;
  cityToExclude?: string;
  latitude?: number;
  longitude?: number;
  distance?: number;
  orderBy?: SearchSortType;
  dayTime?: SearchFilterDayTimeType;
  professionalGender?: SearchFilterProfessionalGenderType;
  minAge?: number;
  maxAge?: number;
  minDate?: string;
  maxDate?: string;
  followUp?: boolean;
  onlyScheduled?: boolean;
  page?: number;
  limit?: number;
}

export interface FindSchedulesByProceduresResult {
  groups: SearchApiScheduleGroup[];
  hasMore: boolean;
}

export async function findSchedulesByProcedures(
  params: FindSchedulesByProceduresParams,
): Promise<FindSchedulesByProceduresResult> {
  const { orderBy, dayTime, professionalGender, followUp, onlyScheduled, ...rest } = params;
  const apiOrderBy = toSearchApiOrderBy(orderBy);
  const apiDayTime = toSearchApiDayTime(dayTime);
  const apiProfessionalGender = toSearchApiProfessionalGender(professionalGender);
  const apiScheduleTypes = toSearchApiScheduleTypes({ SCHEDULED: onlyScheduled });

  const response = await searchApiClient.get<SearchApiListResponse<SearchApiScheduleGroup>>(
    '/schedules/find-by-procedures',
    {
      ...rest,
      ...(apiOrderBy ? { orderBy: apiOrderBy } : {}),
      ...(apiDayTime ? { dayTime: apiDayTime } : {}),
      ...(apiProfessionalGender ? { professionalGender: apiProfessionalGender } : {}),
      ...(followUp ? { followUp } : {}),
      ...(apiScheduleTypes ? { scheduleTypes: apiScheduleTypes } : {}),
    },
  );

  return { groups: response.data.data ?? [], hasMore: response.data.hasMore ?? false };
}
